export class FacebookProviderData {
    uid: string
    email: string
    firstname: string
    lastname: string
    birthday: string
    gender: string
    imageUrl: string
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/auth/facebook-provider-data.model.ts